// @TODO <HEALTH2019>
// Added $rootScope, zochaHealthInsuranceService
App.controller('ZochHealthInsuranceAddCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'zochaInsuranceService', 'statesService', '$filter', 'profileService', 'packageService', 'branchService', 'moment', '$q', 'zochaWorkersService', '$rootScope', 'zochaHealthInsuranceService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, zochaInsuranceService, statesService, $filter, profileService, packageService, branchService, moment, $q, zochaWorkersService, $rootScope, zochaHealthInsuranceService, popUpService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.ref = {};

    $scope.data = {
        originalCopyEntered: true
    };
    $scope.data.user = $scope.stateParams.user;

    if (packageService.isEndOfAccessionZocha()) {
        $state.go('root.home.zoch.manage');
    }

    /**
     * Model for pesel input in readByPeselForm;
     * @type {string}
     */
    $scope.pesel = '';

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.withRehabilitation = false;
    $scope.changeRehabilitationStatus = function () {
        $scope.withRehabilitation = !$scope.withRehabilitation;
        if ($scope.withRehabilitation) {
            $scope.setRehabilitationValues();
        } else {
            $scope.resetRehabilitationValues();
        }
    };

    if ($scope.data.user) {
        $scope.step = 'Wprowadź deklaracje (' + $scope.data.user.person.firstName + ' ' + $scope.data.user.person.lastName + ')';
    } else {
        $scope.step = 'Wprowadź deklaracje';
    }
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthInsurance.list';
    $scope.$emit('link', $scope.link);

    $scope.nationality = 'POLISH';

    // @TODO <HEALTH2019>
    $scope.packages = [];
    $scope.variants = [];

    $scope.variantId = null;
    $scope.packageId = null;

    packageService.dataHealthGroupedPackageLists().then(function (data) {
        console.log('dataHealthGroupedPackageLists', data, data.data);
        if (data.status === 200) {
            $scope.variants = data.data.group;

            var currentVariant = $scope.variants[0];
            $scope.variantId = currentVariant.name;
            $scope.chooseVariant();
        }
    });

    $scope.partner_block = true;
    $scope.children_block = true;

    function updateInsuredPersons() {
        var isPartnerAdded = !!Object.keys($scope.data.partner || {}).length;
        if ($scope.data.children.length) {
            if ($scope.package.children) {
                $scope.data.children.splice($scope.package.children);
                $scope.children_length = $scope.data.children.length;

                if($scope.package.partner){
                    if (isPartnerAdded) {
                        $scope.partner_length = 1;
                    } else {
                        $scope.data.partner = {};
                        $scope.partner_length = 0;
                    }
                }
            } else {
                if ($scope.package.partner) {
                    if (isPartnerAdded) {
                        $scope.data.children = [];
                        $scope.children_length = 0;
                        $scope.partner_length = 1;
                    } else {
                        $scope.data.children.splice(1);
                        $scope.children_length = $scope.data.children.length;
                        $scope.partner_length = 0;
                    }
                } else {
                    $scope.data.partner = {};
                    $scope.partner_length = 0;
                    $scope.data.children = [];
                    $scope.children_length = 0;
                }
            }
        } else if (isPartnerAdded) {
            if ($scope.package.partner) {
                $scope.partner_length = 1;
            } else {
                $scope.data.partner = {};
                $scope.partner_length = 0;
            }
        } else {
            $scope.partner_length = 0;
            $scope.children_length = 0;
        }

        isPartnerAdded = !!Object.keys($scope.data.partner || {}).length;

        var partner_block = true;
        var children_block = true;
        if ($scope.package.children) {
            if ($scope.data.children.length < $scope.package.children) {
                children_block = false;
            } else {
                children_block = true;
            }

            if ($scope.package.partner) {
                if (isPartnerAdded) {
                    partner_block = true;
                } else {
                    partner_block = false;
                }
            } else {
                partner_block = true;
            }
        } else {
            if ($scope.package.partner) {
                if (isPartnerAdded) {
                    partner_block = true;
                    children_block = true;
                } else {
                    if ($scope.data.children.length) {
                        partner_block = true;
                        children_block = true;
                    } else {
                        partner_block = false;
                        children_block = false;
                    }
                }
            } else {
                children_block = true;
            }
        }

        $scope.partner_block = partner_block;
        $scope.children_block = children_block;
    }

    $scope.choosePackage = function () {
        angular.forEach($scope.packages, function (value) {
            if (value.id === $scope.packageId) {
                $scope.package = value;
                $scope.data.benefit = $scope.package;
            }
        });

        updateInsuredPersons();
    };

    $scope.setRehabilitationValues = function () {
        for (var a = 0; a < $scope.packages.length; a++) {
            $scope.packages[a].name += ' + Rehabilitacja';
            $scope.packages[a].summaryPrice += $scope.packages[a].rehabilitationPrice;
        }
    };
    $scope.resetRehabilitationValues = function () {
        for (var a = 0; a < $scope.packages.length; a++) {
            $scope.packages[a].name = $scope.packages[a].name.replace(' + Rehabilitacja', '');
            $scope.packages[a].summaryPrice -= $scope.packages[a].rehabilitationPrice;
        }
    };

    $scope.chooseVariant = function () {
        if ($scope.withRehabilitation) {
            $scope.resetRehabilitationValues();
        }
        angular.forEach($scope.variants, function (value) {
            if (value.name === $scope.variantId) {
                var packages = value.options;
                $scope.packages = packages;

                if ($scope.package) {
                    var sameTypePackage;
                    angular.forEach(packages, function (pkg) {
                        if (pkg.type === $scope.package.type) {
                            sameTypePackage = pkg;
                        }
                    });

                    if (sameTypePackage) {
                        $scope.packageId = sameTypePackage.id;
                    } else {
                        $scope.packageId = packages[0].id;
                    }
                } else {
                    $scope.packageId = packages[0].id;
                }

                if ($scope.withRehabilitation) {
                    $scope.setRehabilitationValues();
                }
                $scope.choosePackage();
            }
        });
    };
    // @TODO </HEALTH2019>

    if ($scope.data.user) {
        $scope.userData = $scope.data.user;

        $scope.ref.selectedItemBranch = $scope.data.user.person.branch;

        $scope.data.person = $scope.userData.person;
        delete $scope.data.person.creationTime;

        $scope.data.userId = $scope.data.user.id;

        console.log($scope.userData);

        if ($scope.userData.person.address) {
            $scope.data.person.address = $scope.userData.person.address;
            delete $scope.data.person.address.creationTime;
            $scope.selectedItemLocalization = $scope.userData.person.address.city;
        }
    } else {
        $scope.data.person = {};
        $scope.data.person.address = {};

        $scope.data.userId = '';
    }

    $scope.acceptStatement = [];
    for (var a = 0; a < 1; a++) {
        $scope.acceptStatement[a] = false;
    }

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];

    $scope.accept = function () {
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    };

    $scope.register = function (form) {
        console.log(form);
        if (!form.$valid) {
            return 0;
        }

        var $data = angular.copy($scope.data);

        var childrenLength = Object.keys($data.children).length;
        var partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                $scope.showPopUp('Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                $scope.showPopUp('Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        if ($data.children && Object.keys($data.children).length) {
            var len = Object.keys($data.children).length;
            for (var a = 0; a < len; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver26FromIdentifier')($data.children[a].identifier)) {
                            $scope.showPopUp('Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver26FromBirthdate')($data.children[a].birthdate)) {
                            $scope.showPopUp('Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.');
                            return 0;
                        }
                    }
                }
            }
        }

        if ($data.partner && Object.keys($data.partner).length) {
            $data.partner.identifierType = ($data.partner.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $data.partner.identifier = ($data.partner.nationality !== 'POLISH') ? $data.partner.id : $data.partner.identifier;
            $data.partner.birthdate = ($data.partner.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.partner.birthdate) : $filter('getDateFromIdentifier')($data.partner.identifier);
            $data.partner.citizenshipType = $data.partner.nationality;
            // $data.partner.address.city = $data.partner.selectedItemLocalization;

            delete $data.partner.selectedItemLocalization;
            delete $data.partner.nationality;
            delete $data.partner.id;
            delete $data.partner.sameAddress;
        } else {
            delete $data.partner;
        }

        if ($data.children && Object.keys($data.children).length) {
            var len = Object.keys($data.children).length;
            for (var a = 0; a < len; a++) {

                $data.children[a].identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                $data.children[a].identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                $data.children[a].birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                $data.children[a].citizenshipType = $data.children[a].nationality;
                // $data.children[a].address.city = $data.children[a].selectedItemLocalization;

                delete $data.children[a].selectedItemLocalization;
                delete $data.children[a].nationality;
                delete $data.children[a].id;
                delete $data.children[a].sameAddress;
            }
        }

        $data.person.identifierType = ($scope.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        $data.person.identifier = ($scope.nationality !== 'POLISH') ? $data.person.id : $data.person.identifier;
        $data.person.birthdate = ($scope.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.person.birthdate) : $filter('getDateFromIdentifier')($data.person.identifier);
        $data.person.citizenshipType = $scope.nationality;
        // $data.person.address.city = $scope.selectedItemLocalization;
        $data.proposedDate = $scope.proposedDate;

        //console.log('test2', angular.copy($data));
        //console.log('test3', $scope);
// @TODO <HEALTH2019>

        var branchId;
        if (typeof $scope.ref.selectedItemBranch.id === 'undefined') {
            if (typeof $data.user.person.branchId !== 'undefined') {
                branchId = $data.user.person.branchId;
            }
        } else {
            branchId = $scope.ref.selectedItemBranch.id;
        }

        $data.branch = {id: branchId};

        if ($scope.withRehabilitation) {
            $data.rehabilitation = true;
        }

        zochaHealthInsuranceService.add($data).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('Gratulacje!', 'Deklaracja została zgłoszona.', 'Przejdź do listy deklaracji', 'root.home.zoch.healthInsurance.list({"user": null})', {
                    text: 'Dodaj kolejną deklarację',
                    reload: true,
                });
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {head: 'Użycie zajętego PESEL/Numer paszportu', content: 'Użytkownik o wskazanym numerze PESEL/Numer paszportu istnieje w systemie. Skontaktuj się z Administratorem.'});
                } else if (data.data.message === 'DuplicateHRNumberException') {
                    popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Użytkownik o wskazanym numerze kadrowym istnieje w systemie. Skontaktuj się z Administratorem.'});
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Użytkownik o wskazanym adresie e-mail istnieje w systemie. Skontaktuj się z Administratorem.'});
                } else {
                    popUpService.showPopUpWithError(data.data, {head: 'Rejestracja nieudana', content: 'Niestety nie udało się zarejestrować konta. Skontaktuj się z administratorem.'});
                }
            }
        });

// @TODO </HEALTH2019>
    };

    $scope.showPopUp = function (head, content, text, target, secondButton) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'locals', function ($scope, $mdDialog, locals) {
                $scope.locals = locals;

                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.confirm = function (payload) {
                    $mdDialog.hide(payload);
                };
            }],
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            clickOutsideToClose: false,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                secondButton: secondButton
            }
        }).then(function (data) {
            if(data && data.reload) {
                $state.reload();
            }
        }, function () {

        });
    };

    $scope.add = function (type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
        }

        if (type === 'CHILD') {
            $scope.data.children.push({
                birthdate: new Date('01/01/2000'),
                nationality: 'POLISH',
                member: 'CHILD',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            });

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
    };

    var getResults = function (query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function (data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function (query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function (results) {
            return results;
        });
    };

    $scope.selectedItemLocalization = null;
    $scope.searchTextLocalization = null;

    $scope.selectedItemMainLocalization = null;
    $scope.searchTextMainLocalization = null;

    $scope.delete = function (obj) {
        if (obj === 'partner') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        }
    }

    $scope.$watch('data.person.address', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    }
                }
            }
        }
    }, true);

    $scope.$watch('selectedItemLocalization', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    }
                }
            }
        }
    }, true);

    var collection = ['data.partner.sameAddress', 'data.children[0].sameAddress', 'data.children[1].sameAddress', 'data.children[2].sameAddress', 'data.children[3].sameAddress', 'data.children[4].sameAddress', 'data.children[5].sameAddress'];
    $scope.$watchGroup(collection, function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                } else {
                    // $scope.data.partner.address = {};
                    // $scope.data.partner.selectedItemLocalization = null;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    } else {
                        // $scope.data.children[a].address = {};
                        // $scope.data.children[a].selectedItemLocalization = null;
                    }
                }
            }
        }
    });

    $scope.notExistEmail = true;
    $scope.$watch('notExistEmail', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.notExistEmail) {
                $scope.data.person.email = '';
            }
        }
    });

    var companyId = 1;
    branchService.dataZochBranchLists(companyId).then(function (data) {
        $scope.branch = data.data.data;
        if (!$rootScope.CONFIGURATOR.zoch.healthInsurance.isBranchEnabled) {
            $scope.ref.selectedItemBranch = $scope.branch[0];
        }
    });

    // ##### FILTER ##### //
    $scope.ref.querySearchBranch = function (query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    }

    var date = new Date();
    var dayOfMonth = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var requiredDayOfMonth = 25;

    // wyjątek dla drugiego miesiąca przystąpień (06.2018)
    if (month === 6 && year === 2018) {
        requiredDayOfMonth = 29;
    }

    if (dayOfMonth <= requiredDayOfMonth) {
        // to najbliższy
        var date = new Date(date.getFullYear(), date.getMonth() + 1);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    } else {
        // to +1 miesiąc
        var date = new Date(date.getFullYear(), date.getMonth() + 2);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    }

    /**
     * Method findByIdentifier busy indicator;
     * If it's true, method won't be executed;
     * @type {boolean}
     */
    $scope.findPending = false;
    /**
     * Fetches user by identifier (pesel);
     * @param form
     */
    $scope.findByIdentifier = function (form) {
        if (form.$invalid) {
            return;
        }
        if ($scope.findPending) {
            return;
        }
        $scope.findPending = true;

        zochaWorkersService.findByIdentifier($scope.pesel)
            .then(function (success) {
                if (!success.data.data.length) {
                    return;
                }
                var userData = success.data.data[0];
                var userPersonData = userData.person;
                userPersonData.address.zipCode = userPersonData.address.zipCode ? userPersonData.address.zipCode.replace(/-/g, '') : '';

                /**
                 * Although this if/else is not necessary here, because it is possible to fetch user by pesel only (polish citizens only);
                 */
                if (userPersonData.identifierType === 'PESEL'
                    || userPersonData.citizenshipType === 'POLISH' || userPersonData.identifierType === null) {
                    $scope.nationality = 'POLISH';
                } else {
                    $scope.nationality = 'OTHER';
                }

                $scope.notExistEmail = !angular.isDefined(userPersonData.email) || !userPersonData.email;

                $scope.selectedItemLocalization = userPersonData.address.city ? {name: userPersonData.address.city} : '';

                if (userPersonData.branchId) {
                    $scope.ref.selectedItemBranch = {name: userPersonData.branch, id: userPersonData.branchId};
                    $scope.data.branch = {id: userPersonData.branchId, name: userPersonData.branch};
                }

                $scope.data.userId = userData.userId;
                $scope.data.person = userPersonData;
            })
            .finally(function () {
                $scope.findPending = false;
            });
    };
}]);
